// --- src/lib/supabaseClient.ts ---
import { createClient } from '@supabase/supabase-js';
import { logger } from '../services/logger';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;
// CRITICAL: Schema must be strictly from environment variable
const supabaseSchema = import.meta.env.VITE_SUPABASE_SCHEMA || 'public';

if (!supabaseUrl || !supabaseAnonKey) {
  logger.error('HIÁNYZÓ SUPABASE ADATOK! Ellenőrizd a .env fájlt.', null, 'SupabaseClient');
  throw new Error('HIÁNYZÓ SUPABASE ADATOK! Ellenőrizd a .env fájlt.');
}

// Production stability: Log schema on boot for Vercel environment verification
console.log(`🚀 BOOTING WITH SCHEMA: ${supabaseSchema}`);

logger.info(
  `Supabase csatlakozva: ${supabaseSchema} séma`,
  { schema: supabaseSchema },
  'SupabaseClient'
);

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  db: {
    schema: supabaseSchema,
  },
});
